export default __webpack_public_path__ + "static/media/no_repeat_period.f01e94b7.svg";